import './PatientDetails.css';

import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { getAgeInYears } from '../../helpers/date.ts';
import type { Patient } from '../../types/patient.type.ts';
import { UserCircle } from '../Icons';

interface PatientDetailsProps {
  patient: Patient;
  withTitle?: boolean;
  size?: 'small' | 'large';
}

export const PatientDetails: FunctionComponent<PatientDetailsProps> = ({
  patient,
  withTitle = true,
  size = 'small',
}) => {
  const { t } = useTranslation();

  const age = getAgeInYears(new Date(patient.birthdate));

  return (
    <div className="patient-details-main-container">
      {withTitle && (
        <p className="text-lg semibold">
          {t('components.PatientDetails.title')}
        </p>
      )}
      <UserCircle size={28} style={{ flexShrink: 0 }} />
      <p
        className={`${size === 'small' ? 'text-base' : 'text-2xl'} semibold patient-details-title-${size}`}
      >
        {patient.code}
      </p>
      <div
        className={`patient-details-container ${size === 'small' ? 'text-base' : 'text-lg'} regular`}
      >
        <p>|</p>
        <p>
          {patient.firstName} {patient.lastName}
        </p>
        <p>|</p>
        <p>{t('components.PatientDetails.age', { age })}</p>
        <p>|</p>
        <p>{t(`components.PatientDetails.sex.${patient.sex}`)}</p>
      </div>
    </div>
  );
};
